export enum TipoSensores {
    TEMPERATURA = 'Temperatura',
    UMIDADE = 'Umidade',
}
